export default __webpack_public_path__ + "static/media/1.de087243.png";